import React, { useState, useEffect } from 'react';
import {
    Container,
} from '@mui/material';
import AdminMenu from '../../components/menu';
import BoFTitle from '../../components/bof-title';
import VideoForm from '../../components/form/video-form';

export default function VideoDetail() {
    return(
        <>
            <AdminMenu/>
            <Container maxWidth="lg" style={{ marginTop: '7rem' }}>
                <BoFTitle
                    title={"Video Detail"}
                    is_main_page={false}
                />
                <VideoForm
                    mode={'edit'}
                    button_title={'Edit'}
                />
            </Container>
        </>
    )
}